import { render, staticRenderFns } from "./select-cms-item-type.vue?vue&type=template&id=2c76b9e2&scoped=true"
import script from "./select-cms-item-type.vue?vue&type=script&lang=js"
export * from "./select-cms-item-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c76b9e2",
  null
  
)

export default component.exports